import { PageActivityFeatures } from 'constants/pageActivityFeatures';

export type AnalyticsTabId = 'customLanding';

export type AnalyticsTabConfig = {
  id: AnalyticsTabId;
  feature: string;
  labelKey: string;
};

export const analyticsTabs: AnalyticsTabConfig[] = [
  {
    id: 'customLanding',
    feature: PageActivityFeatures.CUSTOM_LANDING,
    labelKey: 'CustomLandingActivity',
  },
];

export default analyticsTabs;
